import Accordion from '@/common/components/Accordion'
import Box from '@/common/components/Box'
import Button from '@/common/components/Button'
import { ErrorMessageWrapper } from '@/common/components/ErrorMessageWrapper'
import GoBackButton from '@/common/components/GoBackButton'
import { ImageCarousel } from '@/common/components/ImageCarousel'
import ResumeBox from '@/common/components/ResumeBox'
import { ModalDeleteMaintenanceSolicitation } from '@/features/maintenanceSolicitations/components/ModalDeleteMaintenanceSolicitation'
import { solicitationKindTranslation } from '@/features/maintenanceSolicitations/constants/solicitationKind.constant'
import { useMaintenanceSolicitation } from '@/features/maintenanceSolicitations/hooks/useMaintenanceSolicitation'
import { ChevronsRightIcon } from 'lucide-react'
import { Link, useParams } from 'react-router-dom'

const Show = () => {
  const { id } = useParams()

  const {
    data: maintenanceSolicitation,
    isPending: maintenanceSolicitationIsPending,
    error: maintenanceSolicitationError = {} as any,
    refetch: refetchPermission,
  } = useMaintenanceSolicitation(id || '')

  const disableUpdateButton = maintenanceSolicitationIsPending || maintenanceSolicitationError?.status === 403

  return (
    <div className="flex flex-col gap-y-6">
      <div className="flex justify-between items-center">
        <div className="flex gap-2 items-center">
          <GoBackButton fallback="/maintenance-solicitations" searchLastRouteFromFallback />

          <p>Solicitações</p>

          <ChevronsRightIcon className="text-white-400" />

          <h2>{maintenanceSolicitation?.id}</h2>
        </div>

        <div className="flex gap-4">
          <ModalDeleteMaintenanceSolicitation />

          <Link
            to={disableUpdateButton ? '' : `/maintenance-solicitations/${id}/edit`}
            className={disableUpdateButton ? 'cursor-default' : ''}
          >
            <Button
              name="update_maintenance_solicitation"
              operationKlassToCheckPermission="Client::Maintenance::Solicitations::Update"
              disabled={disableUpdateButton}
            >
              Editar
            </Button>
          </Link>
        </div>
      </div>

      {maintenanceSolicitationIsPending ? (
        <Box>Carregando...</Box>
      ) : (
        <ErrorMessageWrapper
          className="h-[calc(100vh-128px)]"
          statusCode={maintenanceSolicitationError?.status}
          refetchFunction={refetchPermission}
        >
          <Box className="max-h-[calc(100vh-128px)] flex flex-col gap-4 overflow-y-auto">
            <div className="flex w-full gap-x-2">
              {maintenanceSolicitation?.photos && maintenanceSolicitation.photos.length > 0 && (
                <ImageCarousel
                  files={maintenanceSolicitation.photos.map((photo) => ({
                    id: photo.url,
                    file: photo.url,
                  }))}
                  showRemoveButton={false}
                  showNavigationButtons
                  showExpandButton
                />
              )}

              <div className="flex w-full flex-col gap-y-2">
                <div className="flex w-full gap-x-2">
                  <ResumeBox
                    boxClassName="w-full bg-white-200"
                    label="Equipamento"
                    value={maintenanceSolicitation?.equipment?.field_for_display_value || '--'}
                    testId="equipment"
                  />

                  <ResumeBox
                    boxClassName="w-full bg-white-200"
                    label="Tipo de solicitação"
                    value={
                      maintenanceSolicitation?.kind
                        ? solicitationKindTranslation[
                            maintenanceSolicitation.kind as keyof typeof solicitationKindTranslation
                          ] || maintenanceSolicitation.kind
                        : '--'
                    }
                    testId="kind"
                  />
                </div>

                <ResumeBox
                  boxClassName="bg-white-200"
                  label="Descritivo da solicitação"
                  value={maintenanceSolicitation?.observations || '--'}
                  testId="observations"
                />
              </div>
            </div>

            {maintenanceSolicitation?.objectives && maintenanceSolicitation.objectives.length > 0 && (
              <Accordion
                defaultOpen
                className="py-1"
                head={<p>Objetos de manutenção</p>}
                body={
                  <div className="flex w-full flex-col gap-y-2">
                    {maintenanceSolicitation.objectives.map((objective) => (
                      <Box key={objective.id} className="flex w-full flex-col items-start gap-y-2 rounded-lg">
                        <Box className="bg-white-200 p-2">
                          <p className="text-xs">{objective.system.display_name}</p>
                        </Box>

                        <div>
                          <p className="font-bold">{objective.part.display_name}</p>
                          <p className="text-[10px]">{objective.action.display_name}</p>
                        </div>
                      </Box>
                    ))}
                  </div>
                }
              />
            )}
          </Box>
        </ErrorMessageWrapper>
      )}
    </div>
  )
}

export default Show
